module.exports = __webpack_public_path__ + "static/img/bg-en.f03adb15.png";